<template>
  <Teleport to="body">
    <div class="application-notifications bs-foundation" role="region" aria-label="Notifications">
      <div v-for="item in service.items" :key="item.id" class="application-notification" :class="{ 'is-error': item.kind === 'error' }" :role="item.kind === 'error' ? 'alert' : 'status'">
        <AppIcon v-if="item.kind === 'error'" name="error" />
        <span class="application-notification-message">{{ item.message }}</span>
        <AppButton v-for="(action, index) in item.actions" :key="index" variant="inverse" :loading="action.pending" @click="action.run">
          <AppIcon v-if="action.text === 'Undo'" name="undo" :size="18" />{{ action.text }}
        </AppButton>
      </div>
    </div>
  </Teleport>
</template>
<script>
import AppButton from '../components/ui/AppButton.vue';
import AppIcon from '../components/ui/AppIcon.vue';
export default { components: { AppButton, AppIcon }, props: { service: { type: Object, required: true } } };
</script>
